import {DomainObject, oneOf} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import {timestampDate} from 'shared/tools';
import Position from './Position';

class IndeedIntegrationStatus extends DomainObject {
  lastSyncedAt;
  status;
  positions;

  _relations = {
    positions: [Position],
    status: oneOf(['pending', 'active']),
    _dates: ['lastSyncedAt']
  };

  constructor(other) {
    super();

    makeObservable(this, {
      lastSyncedAt: observable,
      status: observable,
      positions: observable,
      lastSyncedAtView: computed,
      isActive: computed
    });

    this.merge(other);
  }

  get lastSyncedAtView() {
    return timestampDate(this.lastSyncedAt);
  }

  get isActive() {
    return this.status === 'active';
  }
}

export default IndeedIntegrationStatus;
